<template>
  <SortDropdown
    :items="sortValues"
    :animation="animation"
    data-test="sort-dropdown-button"
    class="x-z-[3]"
  >
    <template #toggle="{ isOpen }">
      <div
        class="x-button x-button-neutral x-button-outlined x-w-[200px] x-gap-0 desktop:x-px-12"
        :class="{ 'x-w-auto x-gap-4': isMobile }"
      >
        <p class="x-text2 x-line-clamp-1 x-text-left x-font-light">
          {{ $t('sort.label') }}
          <span v-if="!isMobile">{{
            $t(`sort.values.${x.selectedSort || 'default'}`).toLowerCase()
          }}</span>
        </p>
        <ChevronUpIcon
          v-if="isOpen"
          class="x-icon-auxiliary-90 x-icon x-icon-stroke-width-xl x-ml-auto"
        />
        <ChevronDownIcon
          v-else
          class="x-icon-auxiliary-90 x-icon-md x-icon-stroke-width-xl x-ml-auto"
        />
      </div>
    </template>

    <template #item="{ isSelected, item }">
      <div
        class="x-dropdown__item-div x-facet-filter x-w-full x-bg-neutral-0 x-px-16 x-text-neutral-100 hover:x-bg-neutral-10 hover:x-text-neutral-90"
        :class="{ 'x-bg-neutral-25 hover:!x-bg-neutral-25': isSelected }"
      >
        <span class="x-text2 x-text2-sm x-font-semibold">{{
          $t(`sort.values.${item || 'default'}`)
        }}</span>
      </div>
    </template>
  </SortDropdown>
</template>

<script setup lang="ts">
import type { Sort } from '@empathyco/x-types'
import { AnimateScale, ChevronDownIcon, ChevronUpIcon, use$x } from '@empathyco/x-components'
import { SortDropdown } from '@empathyco/x-components/search'
import { useDevice } from '../../composables/use-device.composable'

const { isMobile } = useDevice()
const sortValues: Sort[] = ['', 'price asc', 'price desc']
const x = use$x()
const animation = AnimateScale
</script>
<style lang="scss">
.x-dropdown__items-list {
  width: 200px;
  text-align-last: start;
  padding-top: 12px !important;
  box-shadow: 0 2px 4px rgba(70, 70, 78, 0.0784313725);
}
.x-dropdown__item {
  width: 100%;
}
.x-dropdown__items-list .x-dropdown__list-item:first-child {
  .x-dropdown__item-div {
    border-radius: 4px 4px 0 0;
  }
}
.x-dropdown__items-list .x-dropdown__list-item:last-child {
  .x-dropdown__item-div {
    border-radius: 0 0 4px 4px;
  }
}
</style>
